import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import TopBar from '../components/TopBar';
import LoadingSpinner from '../components/LoadingSpinner';
import Api from '../utils/Api';

import FileIcon from '../assets/file-gradient.png';

import "../style/BillsList.css";

// BillsList Component
class BillsList extends Component {
    constructor() {
        super();
        this.state = {
            bills: null,
            loaded : false,
        };
    }

    componentDidMount() {
        Api.getBills()
        .then((res) => {
            console.log(res);
            this.setState({ bills : res.bills, loaded : true });
        }).catch(err => {
            if (err.status === 403 || err.status === 401) {
                this.setState({ logout: true });
            } else {
                this.setState({ loaded: true });
            }
        });
    }

    getItem(bill, index) {
        const date = moment(bill.issue_date);

        return (<li className="list-group-item bill-item" key={bill.issue_date + index}>
            <div className="bill-icon-wrapper">
                <img src={FileIcon} alt=""/>
            </div>
            <div className="bill-text-wrapper">
                {`Facture du ${date.format('DD/MM/YYYY')}`}
            </div>
            <div className="bill-link-wrapper">
                <a href={bill.view_url} target="_blank" className="btn btn-primary btn-sm">
                    <i className="pe-7s-info"></i>
                    Details
                </a>
            </div>
        </li>);
    }

    render() {
        if (this.state.logout)
            return <Redirect to="/login" />

        const items = this.state.bills && this.state.bills.map((bill, index) => this.getItem(bill, index));

        const list = (
            <ul className="list-group">
                {items}
            </ul>
        );

        const noBillsMessage = (
            <div className="alert alert-info">
                Aucune factures pour l'instant. Merci de revenir plus tard.
            </div>
        );

        return(
            <div className="route-wrapper">
                <TopBar
                    title="Mes factures"
                    subheading="Cliquez sur une facture pour plus de details"
                    icon="pe-7s-graph2"
                />
                <div className="app-inner-layout">
                    <div className="app-inner-layout-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col">
                                    {!this.state.loaded && <LoadingSpinner />}
                                    {this.state.loaded && (this.state.bills && this.state.bills.length ? list : noBillsMessage)}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default BillsList;



// WEBPACK FOOTER //
// ./src/containers/BillsList.js